export default function Medalla({ num}: { num: any; }) {



   if (num==0){

     return (<img  className={"medalla "} src={"./tick.png"}></img>);

  }else if(num==-1){

   return (<img  className={"medalla "} src={"./fail.png"}></img>);

  }else if(num>0){

      return (

          <img  className={"medalla "} src={"./medalla_"+num+".png"}></img>
      )

   }else{

      return (<div></div>);

  }

    



   
  
}